<template>
  <div class="table table-borderless">
    <table>
      <tbody>
        <tr >
          <td v-for="country in ufosByCountry" :key="country.key">
            <a href @click.prevent="addCountryFilter(country)"
            :title="country.value.admin"
            :class="{ selected: isSelected(country.key) }">
            {{ country.key }}</a>
          </td>
        </tr>
        <tr >
          <td v-for="country in ufosByCountry" :key="country.key">
            {{ country.value.count }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import d3 from '@/assets/d3';

import AnimatedBar from '@/components/AnimatedBar.vue';

export default {
  props: ['value', 'ufos'],
  data() {
    return {
      width: 50,
      height: 10,
    };
  },
  computed: {
    ufosByCountry() {
      return d3.nest()
        .key(d => d.properties.adm0_a3)
        .rollup(d => ({ count: d.length, admin: d[0].properties.admin }))
        .entries(this.ufos)
        .sort((a, b) => b.value.count - a.value.count)
        .slice(0, 5);
    },
  },
  methods: {
    addCountryFilter(d) {
      const filters = { ...this.value };
      if (filters.adm0_a3.includes(d.key)) {
        const index = filters.adm0_a3.indexOf(d.key);
        filters.adm0_a3.splice(index, 1);
      } else {
        filters.adm0_a3 = [...filters.adm0_a3, d.key]
          .sort((a, b) => a - b);
      }
      this.$emit('input', filters);
    },
    isSelected(countryName) {
      return this.value.adm0_a3
        .includes(countryName);
    },
  },
  components: {
    AnimatedBar,
  },
};
</script>

<style scoped>
  .content {
    padding: 10px;
  }
  table {
    width: 100%;
    margin: 0px auto;
    font-size: 12px;
    border: 1px solid darkgrey;
    padding: 10px;
    background-color: lightgreen;
  }
  tr {
    margin: 0px;
    padding: 0px;
  }
  td {
    width: 20%;
    padding: 5px;
    color: black;
  }
  a.selected {
    background-color: darkorange !important;
  }

</style>
